import React, { useState } from 'react';
import { Button, Modal, message } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { useHistory } from 'react-router';
import SITELINKS from 'constants/sitelinks';
import { JourneyKind } from 'interfaces/journey';
import { useCreateJourney } from 'services/journeys';
import { forgetLastDraft, lastDraft, rememberLastDraft } from '../../lastDraft';
import { savedDraftBody, savedDraftTitle } from './saveDraftText';

interface SaveDraftModalProps {
  open: boolean;
  journeyId: string;
  kind?: JourneyKind;
  shipments: number;
  collections: number;
  onClose: () => void;
}

const SaveDraftModal = ({
  open,
  journeyId,
  kind,
  shipments,
  collections,
  onClose,
}: SaveDraftModalProps) => {
  const history = useHistory();
  const { mutateAsync: createJourney } = useCreateJourney();
  const [creating, setCreating] = useState(false);
  const routeKind = kind ?? 'shipments';

  const goToPreparation = () => {
    if (lastDraft(routeKind) === journeyId) forgetLastDraft(routeKind);
    onClose();
    history.push(SITELINKS.journeysPrep);
  };

  const createAnother = async () => {
    setCreating(true);
    try {
      const response = await createJourney(routeKind);
      if (!response?.journeyId) throw new Error('No se pudo crear la ruta');
      rememberLastDraft(routeKind, response.journeyId);
      onClose();
      history.push(`${SITELINKS.journey}/${response.journeyId}`);
    } catch (error) {
      console.error(error);
      message.error('No se pudo crear la ruta');
    } finally {
      setCreating(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      maskClosable={false}
      title={
        <span>
          <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8 }} />
          {savedDraftTitle(journeyId)}
        </span>
      }
      footer={[
        <Button key="stay" onClick={onClose} disabled={creating}>
          Seguir con esta ruta
        </Button>,
        <Button key="prep" onClick={goToPreparation} disabled={creating}>
          Ir a Preparación
        </Button>,
        <Button
          key="new"
          type="primary"
          onClick={createAnother}
          loading={creating}
        >
          Crear una nueva
        </Button>,
      ]}
    >
      {savedDraftBody(kind, shipments, collections)}
    </Modal>
  );
};

export default SaveDraftModal;
